import { useTranslation } from 'react-i18next';
import i18n from '../i18n';

export const { t } = i18n;
export default useTranslation;
